import { findIndex, reject, concat } from 'lodash/fp';
import { PATH_BUILDER } from '../../constants/actionTypes';

const editingContentReducer = (state = [], action) => {
  switch (action.type) {
    case PATH_BUILDER.CONTENT.TOGGLE_EDITING: {
      const { id, contentType: type, view } = action;
      const index = findIndex({ id, type })(state);
      return index > -1
        ? reject({ id, type })(state)
        : concat({ id, type, view })(state);
    }

    case PATH_BUILDER.CONTENT.ADD: {
      const { id, contentType: type } = action;
      return concat({ id, type })(state);
    }

    default:
      return state;
  }
};

export default editingContentReducer;
